import { render, staticRenderFns } from "./pointVolunteerList.vue?vue&type=template&id=eb3630e6&scoped=true&"
import script from "./pointVolunteerList.vue?vue&type=script&lang=js&"
export * from "./pointVolunteerList.vue?vue&type=script&lang=js&"
import style0 from "./pointVolunteerList.vue?vue&type=style&index=0&id=eb3630e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3630e6",
  null
  
)

export default component.exports